import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Body, MenuPath, SectionDivider, Warning } from '../ui';

// ── Page ──────────────────────────────────────────────────────────────────

const LoadingTouchSetsDoc: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article className="font-body text-content-primary">
      {/* -- Import -- */}
      <h2
        id="import-touch"
        className="font-display text-[24px] font-extrabold text-content-primary  mb-[16px] tracking-[-0.4px]"
      >
        {t('docs.loadingTouchsets.title')}
      </h2>
      <Body>
        <Trans
          i18nKey="docs.loadingTouchsets.intro"
          components={{ code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>

      <h3 className="font-display text-[17px] font-bold text-content-primary mt-[24px] mb-[10px]">
        {t('docs.loadingTouchsets.importingTitle')}
      </h3>
      <ol className="p-0 mb-[8px] list-none">
        {(
          [
            <Trans
              i18nKey="docs.loadingTouchsets.importStep1"
              components={{ code: <MenuPath>{''}</MenuPath> }}
            />,
            <Trans
              i18nKey="docs.loadingTouchsets.importStep2"
              components={{ code: <MenuPath>{''}</MenuPath> }}
            />,
            <>{t('docs.loadingTouchsets.importStep3')}</>
          ] as React.ReactNode[]
        ).map((step, i) => (
          <li
            key={i}
            className="flex gap-[16px] mb-[16px] items-start"
          >
            <span className="shrink-0 w-[28px] h-[28px] rounded-full bg-surface-hover border-[1.5px] border-border-brand flex items-center justify-center font-display text-[13px] font-bold text-blue-link">
              {i + 1}
            </span>
            <p className="mt-[4px] text-[14px] leading-[1.75] text-content-secondary">
              {step}
            </p>
          </li>
        ))}
      </ol>

      <h3 className="font-display text-[15px] font-bold text-content-primary mt-[20px] mb-[6px]">
        {t('docs.loadingTouchsets.importDialogTitle')}
      </h3>
      <Body>{t('docs.loadingTouchsets.importDialogBody')}</Body>
      <ul className="text-[14px] leading-[1.75] text-content-secondary mb-[16px] pl-[20px]">
        <li>
          <Trans
            i18nKey="docs.loadingTouchsets.importDialogActions"
            components={{ strong: <strong /> }}
          />
        </li>
        <li>
          <Trans
            i18nKey="docs.loadingTouchsets.importDialogLayers"
            components={{ strong: <strong />, code: <MenuPath>{''}</MenuPath> }}
          />
        </li>
        <li>
          <Trans
            i18nKey="docs.loadingTouchsets.importDialogGroups"
            components={{ strong: <strong /> }}
          />
        </li>
        <li>
          <Trans
            i18nKey="docs.loadingTouchsets.importDialogDrawGroups"
            components={{ strong: <strong /> }}
          />
        </li>
      </ul>

      <h3 className="font-display text-[15px] font-bold text-content-primary mt-[20px] mb-[6px]">
        {t('docs.loadingTouchsets.importOptionsTitle')}
      </h3>
      <Body>{t('docs.loadingTouchsets.importOptionsBody')}</Body>
      <ul className="text-[14px] leading-[1.75] text-content-secondary mb-[16px] pl-[20px]">
        <li>
          <Trans
            i18nKey="docs.loadingTouchsets.importOptionFaces"
            components={{ strong: <strong /> }}
          />
        </li>
        <li>
          <Trans
            i18nKey="docs.loadingTouchsets.importOptionColors"
            components={{ strong: <strong /> }}
          />
        </li>
        <li>
          <Trans
            i18nKey="docs.loadingTouchsets.importOptionActions"
            components={{ strong: <strong /> }}
          />
        </li>
      </ul>

      <Warning label={t('docs.loadingTouchsets.warningLabel')}>
        {t('docs.loadingTouchsets.importWarning')}
      </Warning>

      <SectionDivider />

      {/* -- Export -- */}
      <h3 id="export-touch" className="font-display text-[17px] font-bold text-content-primary mb-[10px]">
        {t('docs.loadingTouchsets.exportingTitle')}
      </h3>
      <Body>
        <Trans
          i18nKey="docs.loadingTouchsets.exportBody1"
          components={{ code: <MenuPath>{''}</MenuPath> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.loadingTouchsets.exportBody2"
          components={{ strong: <strong /> }}
        />
      </Body>
      <Body>
        <Trans
          i18nKey="docs.loadingTouchsets.exportSelectedBody"
          components={{ code: <MenuPath>{''}</MenuPath>, strong: <strong /> }}
        />
      </Body>
    </article>
  );
};

export default LoadingTouchSetsDoc;
